/**
 * Minimal pub/sub store for bag-studio UI state.
 */

/**
 * @param {Record<string, unknown>} initial
 */
export function createStore(initial) {
    /** @type {Record<string, unknown>} */
    let state = { ...initial };
    /** @type {Set<(s: Record<string, unknown>) => void>} */
    const listeners = new Set();

    return {
        getState() {
            return state;
        },
        setState(patch) {
            const nextPatch = patch || {};
            const keys = Object.keys(nextPatch);
            let changed = false;
            const next = { ...state };
            keys.forEach((key) => {
                if (!Object.is(next[key], nextPatch[key])) {
                    next[key] = nextPatch[key];
                    changed = true;
                }
            });
            if (!changed) {
                return;
            }
            state = next;
            listeners.forEach((fn) => fn(state));
        },
        subscribe(fn) {
            listeners.add(fn);
            return () => listeners.delete(fn);
        },
    };
}
